module.exports = __webpack_public_path__ + "media/images/main/cover-f4f0fca0d99560d0d3f9bbbf367dc11e.png";